//由于权限key需要一个唯一的key值，路由的名字也需要一个唯一的key值，后端在模块添加页没有增加一个字段，因此两个功能用了同一个key值
import { marketing } from "./authCodeMap/marketing";
import { assets } from "./authCodeMap/assets";
import { dataCenter } from "./authCodeMap/dataCenter";
import { operation } from "./authCodeMap/operation";
import { ncme } from "./authCodeMap/ncme";
import { activity } from "./authCodeMap/activity";
import brand from "./authCodeMap/brand";
import { newCom } from "./authCodeMap/newCommunity";
const map = {
  ...marketing,
  ...assets,
  ...dataCenter,
  ...operation,
  ...ncme,
  ...brand,
  ...activity,
  ...newCom,
  layout: "layout",
  home: "home",
  hc_home: "hc_home",
  doctor_community_home: "doctor_community_home",
  callback: "callback",
  baseData: "baseData",
  baseData_doctorManage: "baseData_doctorManage",
  doctor_baseData_doctorManage: "doctor_baseData_doctorManage",
  doctor_baseData_doctorManage_add: "doctor_baseData_doctorManage_add",
  doctor_baseData_doctorManage_enterprise_add: "doctor_baseData_doctorManage_enterprise_add",
  doctor_baseData_doctorManage_hospital_add: "doctor_baseData_doctorManage_hospital_add",
  doctor_baseData_doctorManage_info: "doctor_baseData_doctorManage_info",
  health_baseData_doctorManage: "health_baseData_doctorManage",
  baseData_doctorManage_joined: "baseData_doctorManage_joined",
  baseData_doctorManage_dataOverview: "baseData_doctorManage_dataOverview",
  baseData_doctorManage_dataOverview_export: "baseData_doctorManage_dataOverview_export",
  baseData_doctorManage_doctor: "baseData_doctorManage_doctor",
  baseData_doctorManage_doctor_export: "baseData_doctorManage_doctor_export",
  baseData_doctorManage_doctor_invite: "baseData_doctorManage_doctor_invite",
  baseData_doctorManage_doctor_link: "baseData_doctorManage_doctor_link",
  baseData_doctorManage_doctor_label: "baseData_doctorManage_doctor_label",
  baseData_doctorManage_doctor_delete: "baseData_doctorManage_doctor_delete",
  baseData_doctorManage_doctor_pass: "baseData_doctorManage_doctor_pass",
  baseData_doctorManage_doctor_reject: "baseData_doctorManage_doctor_reject",
  baseData_doctorManage_credit: "baseData_doctorManage_credit",
  baseData_doctorManage_label: "baseData_doctorManage_label",
  baseData_doctorManage_input: "baseData_doctorManage_input",
  baseData_doctorManage_input_add: "baseData_doctorManage_input_add",
  baseData_doctorManage_input_edit: "baseData_doctorManage_input_edit",
  baseData_doctorManage_input_good_edit: "baseData_doctorManage_input_good_edit",
  baseData_doctorManage_input_delete: "baseData_doctorManage_input_delete",
  baseData_doctorManage_input_detail: "baseData_doctorManage_input_detail",
  baseData_doctorManage_input_bind: "baseData_doctorManage_input_bind",
  baseData_doctorManage_input_online: "baseData_doctorManage_input_online",
  baseData_doctorManage_registry: "baseData_doctorManage_registry",
  baseData_doctorManage_to_auth: "baseData_doctorManage_to_auth",
  baseData_doctorManage_operation_allocation: "baseData_doctorManage_operation_allocation",
  baseData_doctorManage_distribution: "baseData_doctorManage_distribution",
  baseData_doctorManage_distribution_health: "baseData_doctorManage_distribution_health",
  baseData_doctorManage_distribution_doctor: "baseData_doctorManage_distribution_doctor",
  baseData_doctorManage_distribution_operation: "baseData_doctorManage_distribution_operation",
  baseData_doctorManage_export: "baseData_doctorManage_export",
  baseData_doctorManage_label_edit: "baseData_doctorManage_label_edit",
  baseData_doctorManage_label_delete: "baseData_doctorManage_label_delete",
  baseData_doctorManage_label_add: "baseData_doctorManage_label_add",
  baseData_userManage: "baseData_userManage",
  baseData_userManage_user: "baseData_userManage_user",
  baseData_userManage_user_label: "baseData_userManage_user_label",
  baseData_userManage_user_delete: "baseData_userManage_user_delete",
  baseData_visitManage_visit: "baseData_visitManage_visit",
  baseData_visitManage_visit_label: "baseData_visitManage_visit_label",
  baseData_visitManage_visit_delete: "baseData_visitManage_visit_delete",
  // 新医生管理
  health_baseData_doctorManageMent: "health_baseData_doctorManageMent",
  doctor_baseData_doctorManageMent: "doctor_baseData_doctorManageMent",
  baseData_doctorManageMent_list: "baseData_doctorManageMent_list",
  baseData_doctorManageMent_entey_doctor: "baseData_doctorManageMent_entey_doctor",
  baseData_doctorManageMent_invite_doctor: "baseData_doctorManageMent_invite_doctor",
  baseData_doctorManageMent_import_doctor: "baseData_doctorManageMent_import_doctor",
  baseData_doctorManageMent_export_doctor: "baseData_doctorManageMent_export_doctor",
  baseData_doctorManageMent_online_doctor: "baseData_doctorManageMent_online_doctor",
  baseData_doctorManageMent_offline_doctor: "baseData_doctorManageMent_offline_doctor",
  baseData_doctorManageMent_distribute_label: "baseData_doctorManageMent_distribute_label",
  baseData_doctorManageMent_add_label: "baseData_doctorManageMent_add_label",
  baseData_doctorManageMent_edit_doctor: "baseData_doctorManageMent_edit_doctor",
  baseData_doctorManageMent_delete_doctor: "baseData_doctorManageMent_delete_doctor",
  baseData_doctorManageMent_shortMessage_invite: "baseData_doctorManageMent_shortMessage_invite",
  baseData_doctorManageMent_relevance_goods: "baseData_doctorManageMent_relevance_goods",
  baseData_doctorManageMent_check_in_review: "baseData_doctorManageMent_check_in_review",
  baseData_doctorManageMent_pass_through: "baseData_doctorManageMent_pass_through",
  baseData_doctorManageMent_reject: "baseData_doctorManageMent_reject",
  baseData_doctorManageMent_invitationRecord: "baseData_doctorManageMent_invitationRecord",
  baseData_userManage_tourist: "baseData_userManage_tourist",
  baseData_userManage_tourist_delete: "baseData_userManage_tourist_delete",
  baseData_userManage_label: "baseData_userManage_label",
  baseData_userManage_label_edit: "baseData_userManage_label_edit",
  baseData_userManage_label_delete: "baseData_userManage_label_delete",
  baseData_userManage_label_add: "baseData_userManage_label_add",
  baseData_doctorDetail: "baseData_doctorDetail",
  baseData_organizationManage: "baseData_organizationManage",
  baseData_organizationManage_add: "baseData_organizationManage_add",
  baseData_organizationManage_copy: "baseData_organizationManage_copy",
  baseData_organizationManage_upload: "baseData_organizationManage_upload",
  baseData_organizationManage_groupDelete: "baseData_organizationManage_groupDelete",
  baseData_organizationManage_groupOnline: "baseData_organizationManage_groupOnline",
  baseData_organizationManage_share: "baseData_organizationManage_share",
  baseData_organizationManage_visit: "baseData_organizationManage_visit",
  baseData_organizationManage_edit: "baseData_organizationManage_edit",
  baseData_organizationManage_off: "baseData_organizationManage_off",
  baseData_organizationManage_manageDoctor: "baseData_organizationManage_manageDoctor",
  baseData_organizationManage_manageAc: "baseData_organizationManage_manageAc",
  baseData_organizationManage_delete: "baseData_organizationManage_delete",
  baseData_organizationEdit: "baseData_organizationEdit",
  baseData_organizationActiveManage: "baseData_organizationActiveManage",
  baseData_organizationDoctorManage: "baseData_organizationDoctorManage",
  baseData_organizationDetails: "baseData_organizationDetails",
  baseData_organizationDetails_vest: "baseData_organizationDetails_vest",
  baseData_organizationDetails_vest_add: "baseData_organizationDetails_vest_add",
  baseData_organizationDetails_vest_edit: "baseData_organizationDetails_vest_edit",
  baseData_organizationDetails_vest_del: "baseData_organizationDetails_vest_del",
  financeManage_finance: "financeManage_finance",
  financeManage_finance_charge: "financeManage_finance_charge",
  financeManage_finance_download: "financeManage_finance_download",
  financeManage_finance_detail: "financeManage_finance_detail",
  basicSetting: "basicSetting",
  common_login: "common_login",
  common_create: "common_create",
  community_list: "communityList",
  basicSetting_account: "basicSetting_account",
  basicSetting_account_add: "basicSetting_account_add",
  basicSetting_account_edit: "basicSetting_account_edit",
  basicSetting_account_delete: "basicSetting_account_delete",
  basicSetting_setting_doctorActivity: "basicSetting_setting_doctorActivity",
  basicSetting_setting_doctorActivity_save: "basicSetting_setting_doctorActivity_save",
  basicSetting_setting_doctorJoinComunnity: "basicSetting_setting_doctorJoinComunnity",
  basicSetting_setting: "basicSetting_setting",
  basicSetting_setting_save: "basicSetting_setting_save",
  basicSetting_news: "basicSetting_news",
  basicSetting_permission: "basicSetting_permission",
  basicSetting_role: "basicSetting_role",
  basicSetting_role_add: "basicSetting_role_add",
  basicSetting_role_look: "basicSetting_role_look",
  basicSetting_role_edit: "basicSetting_role_edit",
  basicSetting_role_delete: "basicSetting_role_delete",
  basicSetting_addRole: "basicSetting_addRole",
  basicSetting_bind: "basicSetting_bind",
  basicSetting_bind_weibo_bind: "basicSetting_bind_weibo_bind",
  basicSetting_bind_weibo_mainaccount: "basicSetting_bind_weibo_mainaccount",
  basicSetting_bind_weixin_bind: "basicSetting_bind_weixin_bind",
  basicSetting_bind_unweibo: "basicSetting_bind_unweibo",
  basicSetting_bind_rebind: "basicSetting_bind_rebind",
  basicSetting_bind_unwechat: "basicSetting_bind_unwechat",
  basicSetting_agreement: "basicSetting_agreement",
  operationsManage: "operationsManage",
  operationsManage_postBar: "operationsManage_postBar",
  operationsManage_postBar_post: "operationsManage_postBar_post",
  operationsManage_postBar_post_add: "operationsManage_postBar_post_add",
  operationsManage_postBar_post_setTop: "operationsManage_postBar_post_setTop",
  operationsManage_postBar_post_recommend: "operationsManage_postBar_post_recommend",
  operationsManage_postBar_post_online: "operationsManage_postBar_post_online",
  operationsManage_postBar_post_edit: "operationsManage_postBar_post_edit",
  operationsManage_postBar_post_share: "operationsManage_postBar_post_share",
  operationsManage_siteMsg: "operationsManage_siteMsg",
  operationsManage_siteMsg_add: "operationsManage_siteMsg_add",
  operationsManage_siteMsg_delete: "operationsManage_siteMsg_delete",
  operationsManage_postBar_topic: "operationsManage_postBar_topic",
  operationsManage_postBar_topic_export: "operationsManage_postBar_topic_export",
  operationsManage_postBar_topic_add: "operationsManage_postBar_topic_add",
  operationsManage_postBar_topic_recommend: "operationsManage_postBar_topic_recommend",
  operationsManage_postBar_topic_online: "operationsManage_postBar_topic_online",
  operationsManage_postBar_topic_edit: "operationsManage_postBar_topic_edit",
  operationsManage_postBar_topic_share: "operationsManage_postBar_topic_share",
  operationsManage_postBar_commend: "operationsManage_postBar_commend",
  operationsManage_postBar_commend_response: "operationsManage_postBar_commend_response",
  operationsManage_postBar_commend_block: "operationsManage_postBar_commend_block",
  operationsManage_postBar_editPost: "operationsManage_postBar_editPost",
  operationsManage_advertisementManage: "operationsManage_advertisementManage",
  operationManage_advertManage: "operationManage_advertManage",
  operationManage_advertManage_manage: "operationManage_advertManage_manage",
  operationManage_advertManage_manage_homeAdvert: "operationManage_advertManage_manage_homeAdvert",
  operationManage_advertManage_manage_healthCircleAdvert: "operationManage_advertManage_manage_healthCircleAdvert",
  operationManage_advertManage_manage_articleDetailsAdvert: "operationManage_advertManage_manage_articleDetailsAdvert",
  operationManage_advertManage_manage_postDetailsAdvert: "operationManage_advertManage_manage_postDetailsAdvert",
  operationManage_advertManage_manage_shareDetailsAdvert: "operationManage_advertManage_manage_shareDetailsAdvert",
  operationManage_advertManage_data: "operationManage_advertManage_data",
  operationManage_advertManage_export: "operationManage_advertManage_export",
  operationManage_advertManage_submit: "operationManage_advertManage_submit",
  operationManage_advertManage_save: "operationManage_advertManage_save",
  operationManage_pointManage: "operationManage_pointManage",
  operationManage_pointManage_changeState: "operationManage_pointManage_changeState",
  operationManage_pointManage_export: "operationManage_pointManage_export",
  operationManage_pointsMallEdit: "operationManage_pointsMallEdit",
  operationManage_pointsMallList: "operationManage_pointsMallList",
  operationManage_pointsMallList_add: "operationManage_pointsMallList_add",
  operationManage_pointsMallList_export: "operationManage_pointsMallList_export",
  operationManage_pointsMallList_onandoff: "operationManage_pointsMallList_onandoff",
  operationManage_pointsMallList_edit: "operationManage_pointsMallList_edit",
  operationManage_pointDetail: "operationManage_pointDetail",
  operationsManage_pointDetail_pointIncomeDetail: "operationsManage_pointDetail_pointIncomeDetail",
  operationsManage_pointDetail_pointIncomeDetail_export: "operationsManage_pointDetail_pointIncomeDetail_export",
  operationsManage_pointDetail_goodsChangeDetail: "operationsManage_pointDetail_goodsChangeDetail",
  operationsManage_pointDetail_goodsChangeDetail_export: "operationsManage_pointDetail_goodsChangeDetail_export",
  operationsManage_pointDetail_goodsChangeDetail_sendGoods: "operationsManage_pointDetail_goodsChangeDetail_sendGoods",
  operationsManage_pointDetail_goodsChangeDetail_checkDetail: "operationsManage_pointDetail_goodsChangeDetail_checkDetail",
  // community_tieba: "community_tieba", // 运营管理_圈子论坛
  community: "community",
  // community_index: "community_index", // 社区首页
  community_deco: "community_deco",
  community_deco_index: "community_deco_index",
  community_deco_index_share: "community_deco_index_share",
  community_deco_index_submit: "community_deco_index_submit",
  community_deco_index_preview: "community_deco_index_preview",
  community_deco_index_comty_info: "community_deco_index_comty_info",
  community_deco_index_comty_info_update: "community_deco_index_comty_info_update",
  community_deco_index_shop_info_update: "community_deco_index_shop_info_update",
  community_deco_index_on_off_line: "community_deco_index_on_off_line",
  community_deco_tieba: "community_deco_tieba",
  community_deco_tieba_submit: "community_deco_tieba_submit",
  community_audit: "community_audit",
  community_info: "community_info",
  health_community_info: "health_community_info",
  doctor_community_info: "doctor_community_info",
  community_register: "community_register",
  community_lastinfo: "community_lastinfo",
  content: "content",
  content_classify: "content_classify",
  content_classify_add: "content_classify_add",
  content_classify_online: "content_classify_online",
  content_classify_sort: "content_classify_sort",
  content_classify_edit: "content_classify_edit",
  content_classify_delete: "content_classify_delete",
  content_allEdit: "content_allEdit",
  content_label: "content_label",
  content_label_add: "content_label_add",
  content_label_online: "content_label_online",
  content_label_edit: "content_label_edit",
  content_label_delete: "content_label_delete",
  content_allIndex: "content_allIndex",
  content_popularLive: "content_popularLive",
  content_allIndex_add: "content_allIndex_add",
  content_allIndex_export: "content_allIndex_export",
  content_allIndex_award: "content_allIndex_award",
  content_allIndex_online: "content_allIndex_online",
  content_allIndex_edit: "content_allIndex_edit",
  content_allIndex_share: "content_allIndex_share",
  content_allIndex_classify: "content_allIndex_classify",
  content_allIndex_tag: "content_allIndex_tag",
  content_clinic: "content_clinic",
  content_liveCollection: "content_liveCollection",
  content_liveCollection_waiting: "content_liveCollection_waiting",
  content_liveCollection_waiting_collection: "content_liveCollection_waiting_collection",
  content_liveCollection_waiting_visit: "content_liveCollection_waiting_visit",
  content_liveCollection_waiting_reject: "content_liveCollection_waiting_reject",
  content_liveCollection_accept: "content_liveCollection_accept",
  content_liveCollection_accept_visit: "content_liveCollection_accept_visit",
  content_liveCollection_reject: "content_liveCollection_reject",
  content_liveCollection_reject_visit: "content_liveCollection_reject_visit",
  content_clinic_waiting: "content_clinic_waiting",
  content_clinic_waiting_accept: "content_clinic_waiting_accept",
  content_clinic_waiting_reject: "content_clinic_waiting_reject",
  content_clinic_waiting_export: "content_clinic_waiting_export",
  content_clinic_accept: "content_clinic_accept",
  content_clinic_accept_export: "content_clinic_accept_export",
  content_clinic_accept_online: "content_clinic_accept_online",
  content_clinic_accept_reward: "content_clinic_accept_reward",
  content_clinic_accept_label: "content_clinic_accept_label",
  content_clinic_accept_groupLabel: "content_clinic_accept_groupLabel",
  content_clinic_accept_classify: "content_clinic_accept_classify",
  content_clinic_accept_groupClassify: "content_clinic_accept_groupClassify",
  content_clinic_reject: "content_clinic_reject",
  content_clinic_reject_delete: "content_clinic_reject_delete",
  content_clinic_reject_export: "content_clinic_reject_export",
  content_special_topic: "content_special_topic",
  content_special_topic_edit: "content_special_topic_edit",
  content_special_topic_add: "content_special_topic_add",
  content_special_topic_online: "content_special_topic_online",
  content_special_topic_recommend: "content_special_topic_recommend",
  content_special_topic_delete: "content_special_topic_delete",
  content_qa: "content_qa",
  content_qa_question: "content_qa_question",
  content_qa_question_export: "content_qa_question_export",
  content_qa_question_edit: "content_qa_question_edit",
  content_qa_question_recommend: "content_qa_question_recommend",
  content_qa_question_online: "content_qa_question_online",
  content_qa_question_share: "content_qa_question_share",
  content_qa_anwser: "content_qa_anwser",
  content_qa_anwser_online: "content_qa_anwser_online",
  content_qa_comment: "content_qa_comment",
  content_qa_comment_cancel: "content_qa_comment_cancel",
  content_live: "content_live",
  content_live_add: "content_live_add",
  content_live_online: "content_live_online",
  content_live_visit: "content_live_visit",
  content_live_edit: "content_live_edit",
  content_live_delete: "content_live_delete",
  activityManage: "activtyManage",
  activityManage_invite_add: "activityManage_invite_add",
  activityManage_invite_detail: "InviteDetails",
  activityManage_qsInvite: "activityManage_qsInvite",
  activityManage_qsInvite_qsInvite: "activityManage_qsInvite_qsInvite",
  activityManage_qsInvite_qsInvite_add: "activityManage_qsInvite_qsInvite_add",
  activityManage_qsInvite_qsInvite_export: "activityManage_qsInvite_qsInvite_export",
  activityManage_qsInvite_qsInvite_edit: "activityManage_qsInvite_qsInvite_edit",
  activityManage_qsInvite_qsInvite_filter: "activityManage_qsInvite_qsInvite_filter",
  activityManage_qsInvite_qsInvite_close: "activityManage_qsInvite_qsInvite_close",
  activityManage_qsInvite_qsFiltrate: "activityManage_qsInvite_qsFiltrate",
  activityManage_qsInvite_qsFiltrate_accept: "activityManage_qsInvite_qsFiltrate_accept",
  activityManage_qsInvite_qsFiltrate_reject: "activityManage_qsInvite_qsFiltrate_reject",
  activityManage_qsInvite_qsAccept: "activityManage_qsInvite_qsAccept",
  activityManage_qsInvite_qsAccept_recall: "activityManage_qsInvite_qsAccept_recall",
  activityManage_qsInvite_qsAccept_reward: "activityManage_qsInvite_qsAccept_reward",
  activityManage_qsInvite_qsRefused: "activityManage_qsInvite_qsRefused",
  activityManage_qsInvite_qsRefused_recall: "activityManage_qsInvite_qsRefused_recall",
  activityManage_qsInvite_qsRefused_delete: "activityManage_qsInvite_qsRefused_delete",
  activityManage_contentInvite: "activityManage_contentInvite",
  activityManage_contentInvite_inviteManage: "activityManage_contentInvite_inviteManage",
  activityManage_contentInvite_inviteManage_add: "activityManage_contentInvite_inviteManage_add",
  activityManage_contentInvite_inviteManage_export: "activityManage_contentInvite_inviteManage_export",
  activityManage_contentInvite_inviteManage_edit: "activityManage_contentInvite_inviteManage_edit",
  activityManage_contentInvite_inviteManage_filter: "activityManage_contentInvite_inviteManage_filter",
  activityManage_contentInvite_inviteManage_close: "activityManage_contentInvite_inviteManage_close",
  activityManage_contentInvite_inviteManage_copy: "activityManage_contentInvite_inviteManage_copy",
  activityManage_contentInvite_inviteManage_closePub: "activityManage_contentInvite_inviteManage_closePub",
  activityManage_contentInvite_screen: "activityManage_contentInvite_screen",
  activityManage_contentInvite_screen_export: "activityManage_contentInvite_screen_export",
  activityManage_contentInvite_screen_accept: "activityManage_contentInvite_screen_accept",
  activityManage_contentInvite_screen_multiAccept: "activityManage_contentInvite_screen_multiAccept",
  activityManage_contentInvite_screen_reject: "activityManage_contentInvite_screen_reject",
  activityManage_contentInvite_screen_cnki: "activityManage_contentInvite_screen_cnki",
  activityManage_contentInvite_adopted: "activityManage_contentInvite_adopted",
  activityManage_contentInvite_adopted_export: "activityManage_contentInvite_adopted_export",
  activityManage_contentInvite_adopted_recall: "activityManage_contentInvite_adopted_recall",
  activityManage_contentInvite_adopted_reward: "activityManage_contentInvite_adopted_reward",
  activityManage_contentInvite_adopted_online: "activityManage_contentInvite_adopted_online",
  activityManage_contentInvite_adopted_label: "activityManage_contentInvite_adopted_label",
  activityManage_contentInvite_adopted_classify: "activityManage_contentInvite_adopted_classify",
  activityManage_contentInvite_adopted_editGradeId: "activityManage_contentInvite_adopted_editGradeId",
  activityManage_contentInvite_adopted_gradeReward: "activityManage_contentInvite_adopted_gradeReward",
  activityManage_contentInvite_adopted_multiClassify: "activityManage_contentInvite_adopted_multiClassify",
  activityManage_contentInvite_adopted_multiLabel: "activityManage_contentInvite_adopted_multiLabel",
  activityManage_contentInvite_adopted_multiOnline: "activityManage_contentInvite_adopted_multiOnline",
  activityManage_contentInvite_adopted_multiOffline: "activityManage_contentInvite_adopted_multiOffline",
  activityManage_contentInvite_adopted_multiGradeReward: "activityManage_contentInvite_adopted_multiGradeReward",
  activityManage_contentInvite_adopted_multiReward: "activityManage_contentInvite_adopted_multiReward",
  activityManage_contentInvite_rejected: "activityManage_contentInvite_rejected",
  activityManage_contentInvite_rejected_export: "activityManage_contentInvite_rejected_export",
  activityManage_contentInvite_rejected_recall: "activityManage_contentInvite_rejected_recall",
  activityManage_contentInvite_rejected_delete: "activityManage_contentInvite_rejected_delete",
  activityManage_landingPage: "activityManage_landingPage",
  activityManage_landingPage_add: "activityManage_landingPage_add",
  activityManage_landingPage_edit: "activityManage_landingPage_edit",
  activityManage_landingPage_guide: "activityManage_landingPage_guide",
  activityManage_landingPage_visit: "activityManage_landingPage_visit",
  activityManage_landingPage_share: "activityManage_landingPage_share",
  activityManage_landingPage_online: "activityManage_landingPage_online",
  activityManage_landingPage_groupOnline: "activityManage_landingPage_groupOnline",
  activityManage_voteManage_index: "activityManage_voteManage_index",
  activityManage_voteManage_index_add: "activityManage_voteManage_index_add",
  activityManage_voteManage_index_edit: "activityManage_voteManage_index_edit",
  activityManage_voteManage_index_look: "activityManage_voteManage_index_look",
  operationTools: "operationTools",
  operationTools_questionnaire: "operationTools_questionnaire",
  questionnaire_answerSheetPage: "questionnaire_answerSheetPage",
  questionnaire_answerSheetDetail: "questionnaire_answerSheetDetail",
  operationTools_measurementHeight: "operationTools_measurementHeight",
  operationTools_measurementHeight_dataList: "operationTools_measurementHeight_dataList",
  operationTools_measurementHeight_detail: "operationTools_measurementHeight_detail",
  marketing: "marketing",
  invite_acticity_manage: "invite_acticity_manage",
  activity_registration: "activity_registration",
  activity_registration_sign: "activity_registration_sign",
  activity_registration_detail: "activity_registration_detail",
  activity_registration_order: "activity_registration_order",
  activity_registration_edit: "activity_registration_edit",
  order_record: "order_record",
  grade_management: "grade_management",
  city_budget: "city_budget",
  city_budget_add: "city_budget_add",
  city_budget_detail: "city_budget_detail",
  city_budget_enable_disable: "city_budget_enable_disable",
  city_budget_view: "city_budget_view",
  city_budget_edit: "city_budget_edit",
  brand: "brand",
  brand_case_collection: "brand_case_collection",
  brand_case_activity: "brand_case_activity",
  brand_case_activity_add: "brand_case_activity_add",
  brand_case_activity_edit: "brand_case_activity_edit",
  brand_case_activity_end: "brand_case_activity_end",
  brand_case_activity_copyEdit: "brand_case_activity_copyEdit",
  brand_case_activity_visit: "brand_case_activity_visit",
  brand_case_activity_copy: "brand_case_activity_copy",
  brand_case_activity_Detail: "brand_case_activity_Detail",
  brand_case_manager: "brand_case_manager",
  brand_case_manager_adopt: "brand_case_manager_adopt",
  brand_case_manager_refuse: "brand_case_manager_refuse",
  brand_case_manager_cancel_adopt: "brand_case_manager_cancel_adopt",
  brand_case_manager_high: "brand_case_manager_high",
  brand_case_manager_recall_high: "brand_case_manager_recall_high",
  brand_case_manager_high_detail: "brand_case_manager_high_detail",
  brand_case_manager_online: "brand_case_manager_online",
  brand_case_manager_delete: "brand_case_manager_delete",
  transaction: "transaction",
  transaction_goods_management: "transaction_goods_management",
  transaction_goods_management_add: "transaction_goods_management_add",
  transaction_goods_management_groupOnline: "transaction_goods_management_groupOnline",
  transaction_goods_management_sync: "transaction_goods_management_sync",
  transaction_goods_management_edit: "transaction_goods_management_edit",
  transaction_goods_management_online: "transaction_goods_management_online",
  transaction_goods_management_delete: "transaction_goods_management_delete",
  transaction_clue_management: "transaction_clue_management",
  transaction_clue_management_detail: "transaction_clue_management_detail",
  transaction_clue_management_edit: "transaction_clue_management_edit",
  transaction_consumption_management: "transaction_consumption_management"
};
export default map;